// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as PilotClozeDropBucketDisplay$LiteracyplanetTupperware from "./PilotClozeDropBucketDisplay.res.mjs";

function cols(numColumns) {
  var s = Curry._1(Css.style, {
        hd: Css.gridTemplateColumns({
              hd: {
                NAME: "repeat",
                VAL: [
                  {
                    NAME: "num",
                    VAL: numColumns
                  },
                  {
                    NAME: "fr",
                    VAL: 1.0
                  }
                ]
              },
              tl: /* [] */0
            }),
        tl: {
          hd: Css.borderColor(Skillet$LiteracyplanetTupperware.darkBlue),
          tl: /* [] */0
        }
      });
  var m = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.marginTop,
          50
        ],
        tl: {
          hd: [
            Css.borderTopWidth,
            5
          ],
          tl: /* [] */0
        }
      });
  return Curry._1(Css.merge, {
              hd: Skillet$LiteracyplanetTupperware.SkilfulClozeDropBucketDisplay.className,
              tl: {
                hd: m,
                tl: {
                  hd: s,
                  tl: /* [] */0
                }
              }
            });
}

function SkilfulClozeDropBucketDisplay$Skilful__(props) {
  return React.createElement("div", {
              className: cols(props.numColumns)
            }, props.children);
}

var Skilful__ = {
  ratio: Theme$LiteracyplanetClientFlags.resize,
  cols: cols,
  make: SkilfulClozeDropBucketDisplay$Skilful__
};

function SkilfulClozeDropBucketDisplay(props) {
  var children = props.children;
  var numColumns = props.numColumns;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotClozeDropBucketDisplay$LiteracyplanetTupperware.make, {
                numColumns: numColumns,
                children: children
              });
  } else {
    return React.createElement(SkilfulClozeDropBucketDisplay$Skilful__, {
                numColumns: numColumns,
                children: children
              });
  }
}

var make = SkilfulClozeDropBucketDisplay;

var $$default = SkilfulClozeDropBucketDisplay;

export {
  Skilful__ ,
  make ,
  $$default as default,
}
/* Css Not a pure module */
